<template>
	<select @change='change' v-model="selected" class='form-control my-control table-control'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const ACTION_TYPE = 'get_action_type.php'
	const LOCATION = 'get_act_location.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'actionType',
		data: function () { 
			return {
				selected: '0',
				options: []
			}
		},
		props: {
			line_count: '',
			at_id: ''
		},
		methods: {
			change () {
				EventBus.$emit(`edit_action_type`, {index: this.line_count, value: this.selected})
			},
		},
		created: function () {
			if(this.$parent.data_location.action_type == null)
			{
				EventBus.$on('fetch_action_type_complete', (data) => {
					if (data) {
						this.selected = this.at_id ?  this.at_id : '0'
						this.options = data
					}
					else {
						this.options = []
						this.selected = '0'
					}
					EventBus.$off('fetch_action_type_complete')
				})
			}
			else
			{
				let data = this.$parent.data_location.action_type
				if (data) {
					this.selected = this.at_id ?  this.at_id : '0'
					this.options = data
				}
				else {
					this.options = []
					this.selected = '0'
				}
			}

			
		},
		beforeDestroy () {
			EventBus.$off('fetch_action_type_complete')
		}
	}
</script>


// WEBPACK FOOTER //
// actionType.vue?a81d6b12